import { httpClient } from '../network/httpclient/HttpClientFactory';
import { wrapHttpClient } from '../helper/HttpHelper';
import authHeader from './Header';
const subCodeList = (code, depth) =>
    httpClient.get(`/code/${code}/${depth}`, { headers: authHeader() }).then(res => res.data);

export default {
    subCodeList: wrapHttpClient(subCodeList)
};
